import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import fr from 'vuetify/es5/locale/fr'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { fr },
    current: 'fr'
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        valid: '#47A4A9',
        validLight: '#94CAD1',
        cancel: '#D77E75',
        other1: '#6D98D5',
        other2: '#CDE0FA',
        other3: '#BFBFBF'
      }
    }
  }
})
